import { ScheduleDTO } from './schedule-dto.model';
import { MonitorScheduleInterface } from '../../../interfaces/monitor-schedule.interface';

export class CreateScheduleDTO extends ScheduleDTO {
  Monitors: MonitorScheduleInterface[];
  PlaylistId: number;

  constructor(values: Partial<CreateScheduleDTO> = {}) {
    super();
    Object.assign(this, values);

    this.StartTime = this.transformTimeToString(this.StartTime);
    this.EndTime = this.transformTimeToString(this.EndTime);
    this.StartDate = this.transformDateToString(this.StartDate);
    this.EndDate = this.transformDateToString(this.EndDate);
  }
}
